module.exports = __webpack_public_path__ + "static/img/xstm.961b0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xstm.png
// module id = P6j5
// module chunks = 1